import { TipoExameEnum } from 'graphql/types.generated'
import { emptyArray } from 'util/array'
import { stringGrouper } from 'util/string/string-grouper'
import { createValidator, maxLength, required } from 'util/validation'

import { nomeCodigoProcedimentoRef } from '../../objetivo/resultados-exames/util-resultadosExames'
import { SolicitacaoExameModel } from './model-solicitacaoExames'

function validateProcedDuplicado(values: SolicitacaoExameModel, idsExmAdicionadosAtend: Set<ID>) {
  if (idsExmAdicionadosAtend?.size > 0) {
    const examesSelecionados = values.examesSolicitados ?? emptyArray

    const examesDuplicados = examesSelecionados.filter((exameSel) => idsExmAdicionadosAtend.has(exameSel.exame?.id))

    if (examesDuplicados.length > 0) {
      const nomesCodigos = examesDuplicados.map(({ exame }) => {
        const [nome, codigo] = nomeCodigoProcedimentoRef(exame)
        return `${nome} - ${codigo}`
      })

      return `OCI já solicitado neste atendimento: ${stringGrouper(...nomesCodigos)}. É necessário excluir para salvar.`
    }
  }
}

export function createSolicitacaoExameValidator(idsExmAdicionadosAtend: Set<ID>) {
  return createValidator<SolicitacaoExameModel>(
    {
      examesSolicitados: [required],
      justificativa: [required, maxLength(500)],
      observacao: [maxLength(250)],
    },
    (values, errors) => {
      if (values.tipoExame === TipoExameEnum.ALTO_CUSTO || values.tipoExame === TipoExameEnum.OCI) {
        errors.cid10 = required(values.cid10)
      }

      if (values.tipoExame === TipoExameEnum.OCI) {
        const erroDuplicidadeOCI = validateProcedDuplicado(values, idsExmAdicionadosAtend)
        if (erroDuplicidadeOCI) {
          errors.examesSolicitados = erroDuplicidadeOCI
        }
      }

      return errors
    }
  )
}
